var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 375 346.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.76,172a25.31,25.31,0,0,0,23.78,26.65c.49,0,1,0,1.46,0A25.26,25.26,0,1,0,102.76,172Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62,165.5a8.16,8.16,0,1,0,7.69,8.61A8.15,8.15,0,0,0,8.62,165.5Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.16,25.43a8.16,8.16,0,1,0-11-3.62A8.18,8.18,0,0,0,101.16,25.43Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.78,70.1a12.61,12.61,0,1,0-16.94-5.59A12.62,12.62,0,0,0,126.78,70.1Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.58,100.82a10.39,10.39,0,1,0-3-14.38A10.39,10.39,0,0,0,40.58,100.82Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.93,161a12.62,12.62,0,1,0,11.88,13.31A12.62,12.62,0,0,0,55.93,161Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,245.72a10.39,10.39,0,1,0,13.95,4.6A10.37,10.37,0,0,0,42,245.72Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,134.89a14.84,14.84,0,1,0-4.27-20.55A14.83,14.83,0,0,0,91,134.89Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.47,69.1a12.62,12.62,0,1,0-3.63-17.47A12.61,12.61,0,0,0,246.47,69.1Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.35,24.57A8.16,8.16,0,1,0,270,13.26,8.16,8.16,0,0,0,272.35,24.57Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.45,147.91a25.25,25.25,0,0,0-2.87,50.42c.49,0,1,0,1.45,0a25.25,25.25,0,0,0,1.42-50.46Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.08,133.14A25.12,25.12,0,0,0,157.64,147a25.25,25.25,0,0,0,22.54-36.62,25.25,25.25,0,1,0-45.1,22.73Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,100.79a10.39,10.39,0,1,0-14-4.6A10.4,10.4,0,0,0,333,100.79Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,108.83a14.84,14.84,0,1,0,19.94,6.58A14.86,14.86,0,0,0,269,108.83Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.55,20.76a10.39,10.39,0,1,0-9.79-11A10.38,10.38,0,0,0,186.55,20.76Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.43,86.13a14.84,14.84,0,1,0-14-15.66A14.84,14.84,0,0,0,186.43,86.13Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,237.68a14.84,14.84,0,1,0-19.93-6.58A14.85,14.85,0,0,0,106,237.68Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,107.79a25.22,25.22,0,1,0,21.14-11.41A25.28,25.28,0,0,0,196,107.79Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.92,213.37a25.26,25.26,0,1,0-11.18,33.91A25.11,25.11,0,0,0,239.92,213.37Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,211.62a14.84,14.84,0,1,0,4.27,20.55A14.84,14.84,0,0,0,284,211.62Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.38,173.68a12.62,12.62,0,1,0-13.31,11.88A12.62,12.62,0,0,0,332.38,173.68Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.3,164.71a8.16,8.16,0,1,0,7.69,8.61A8.17,8.17,0,0,0,367.3,164.71Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.42,245.68a10.39,10.39,0,1,0,3,14.39A10.39,10.39,0,0,0,334.42,245.68Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.65,321.94a8.16,8.16,0,1,0,2.34,11.3A8.17,8.17,0,0,0,102.65,321.94Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.83,321.08a8.16,8.16,0,1,0,11,3.62A8.16,8.16,0,0,0,273.83,321.08Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,238.71a25.25,25.25,0,1,0-21.14,11.41A25.1,25.1,0,0,0,179,238.71Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.53,277.41a12.62,12.62,0,1,0,3.63,17.47A12.62,12.62,0,0,0,128.53,277.41Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.38,325.74a10.39,10.39,0,1,0,9.78,11A10.39,10.39,0,0,0,187.38,325.74Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.49,260.37a14.84,14.84,0,1,0,14,15.67A14.85,14.85,0,0,0,187.49,260.37Z",
    fill: "#0033ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.21,276.4a12.62,12.62,0,1,0,17,5.59A12.62,12.62,0,0,0,248.21,276.4Z",
    fill: "#0033ad"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaLogo);
export default __webpack_public_path__ + "static/media/ADALogo.9b8b26ef25c483a1bd528cc2aded7c93.svg";
export { ForwardRef as ReactComponent };